// extracted by mini-css-extract-plugin
export var boldText = "_6x-4";
export var checkboxContainer = "_6x-6";
export var closeIcon = "_6x-i";
export var container = "_6x-0";
export var drawer = "_6x-8";
export var drawerContent = "_6x-9";
export var extraSmallText = "_6x-5";
export var fulfillmentGroupTable = "_6x-e";
export var largeText = "_6x-3";
export var loadingSpinnerContainer = "_6x-j";
export var mediumText = "_6x-2";
export var narrow = "_6x-f";
export var notificationLink = "_6x-l";
export var packageCheckIconContainer = "_6x-7";
export var slideoutHeaderActions = "_6x-g";
export var slideoutHeaderActionsShifted = "_6x-h";
export var slideoutHeaderContainer = "_6x-a";
export var slideoutModal = "_6x-c";
export var stickyHeaderWrapper = "_6x-b";
export var table = "_6x-k";
export var tableContainer = "_6x-d";
export var tertiaryText = "_6x-1";